import { useState, useEffect } from 'react'
import axios from 'axios'
import { useLocale } from 'hooks'
import type { LacedAvailableLocations } from 'types/localisation'

export const useCountryList = (options: UseCountryListOptions = {}) => {
  const { localiseUrl } = useLocale()
  const { query = '' } = options

  const [countries, setCountries] = useState<CountryProps[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const apiUrl = localiseUrl(`/api/countries?filter=${query}`, {
    localeAsParam: true
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrl)
        const { data } = response

        setCountries(data.countries)
      } catch (error) {
        setError('Error fetching country list')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [apiUrl])

  return { countries, loading, error }
}

interface UseCountryListOptions {
  query?:
    | 'Supported'
    | 'EU'
    | 'EEA_ONLY'
    | 'ALL_EEA'
    | 'Seller'
    | 'Asia'
    | 'RemoteUK'
    | 'Priority'
    | 'All'
  onCountriesLoaded?: (countries: unknown[]) => void
  dontUpdateDialingCode?: boolean
}

export interface CountryProps {
  name: string
  code: LacedAvailableLocations
  fee: string
  numeric_code: string
}
